import { OclDecisionsListItemComponent } from './components/ocl-decisions-list-item/ocl-decisions-list-item.component';
import { OclLogbookListItemComponent } from './components/ocl-logbook-list-item/ocl-logbook-list-item.component';

export const OCL_DYNAMIC_COMPONENT = [OclLogbookListItemComponent, OclDecisionsListItemComponent];
